import React from "react";
import PropTypes from "prop-types";
import { Component } from "react";
import HelperContent from "../../helperContent/HelperContent";
import QuestionLabel from "../../question/QuestionLabel";
import QuestionOption from "../../question/QuestionOption";
import { findAnswer } from '../../../state/questionStates';

class FacialExaminationResults extends Component {
    render() {
        let question = this.props.question;
        let store = this.props.store;
        let message;
        let showOptions;

        let answer = findAnswer(store.getState(), "facial-examination-results", "facialMatch");
        if (answer && answer.value && answer.value.startsWith("Yes")) {
            message = "Success - Your verification process is complete";
            showOptions = (
                <div>
                    <ul className="w3-ul w3-border w3-padding-small w3-margin-top">
                        {question.options.map(option => {
                            if (option.itemID === "option-0") {
                                return (
                                <li className="question-option w3-xlarge w3-center" key={option.itemID}>
                                    <QuestionOption option={option} onClick={() => store.dispatch({ type: option.action, selectedOption: option })} />
                                </li>);
                            }
                            return null;
                        })}
                    </ul>
                </div>);
        }
        else {
            message = "It appears your Photo ID does not match your Self-portrait. No worries, try uploading your Photo ID using good lighting against a solid backround.";
            showOptions = (
                <div>
                    <ul className="w3-ul w3-border w3-padding-small w3-margin-top">
                    {question.options.map(option => {
                            if (option.itemID === "option-1") {
                                return (
                                <li className="question-option w3-xlarge w3-center" key={option.itemID}>
                                    <QuestionOption option={option} onClick={() => store.dispatch({ type: option.action, selectedOption: option })} />
                                </li>);
                            }
                            return null;
                        })}
                    </ul>
                </div>);
        }
        
        return (
            <div className="form w3-header w3-animate-opacity">
                <QuestionLabel question={question} store={store}/>
                <HelperContent question={question} />

                <div id="myText" className="w3-panel w3-large w3-center w3-opacity">
                    {message}
                </div>

                {showOptions}
            </div>
        )
    }
};

FacialExaminationResults.propTypes = {
    question: PropTypes.object,
    store: PropTypes.object
};

export default FacialExaminationResults;
